<template>
  <quick-card title="Class Sections">
  <template v-slot:header-actions>
     <v-btn color="primary" icon class="elevation-3" @click="showD=!showD">
          <v-icon>add</v-icon>
     </v-btn>
  </template>
    <template v-slot:card-content>

           <v-data-table
                    :headers="sections_headers"
                    :items="sections"
                    class="elevation-0"
                    :search="search"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.index + 1 }}</td>
                      <td class="text-xs-center">{{ props.item.section }}</td>
                      <td class="text-xs-center">
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-btn flat icon color="blue">
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn
                              flat
                              icon
                              color="pink"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>

                  <m-dialog title="Class Section" :show="showD" pers>

                    <template v-slot:header-actions>
                      <v-btn @click="showD=!showD" icon style="cursor:pointer">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:content>

                      <v-form>
                        <v-text-field label="Section Name"/>
                      </v-form>
                      
                    </template>

                    <template v-slot:footer-actions>
                      <v-btn style="cursor:pointer" color="success">
                       save
                      </v-btn>
                      <v-btn @click="showD=!showD" style="cursor:pointer" color="error">
                       close
                      </v-btn>
                      
                    </template>


                  </m-dialog>
    </template>
  </quick-card>
</template>

<script>
import QuickCard from "../Quickcard";
import Mdialog from "../Modal"
export default {
  name: "class-sections",
  components: {
    "quick-card": QuickCard,
    "m-dialog":Mdialog
  },
  data() {
    return {
      showD:false,
      pers:false,
      search:'',
      sections_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn"
        },
        {
          text: "Section",
          align: "center",
          sortable: false,
          value: "section"
        },
         {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      sections:[]
    };
  }

};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/settings/classSections.vue